var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
export class FontLoader {
    static load(productID, fontName, styleName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.fonts[productID])
                this.fonts[productID] = {};
            if (this.fonts[productID][styleName])
                return;
            var styleHTML = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'get_fontstyle_css',
                    product_id: productID,
                    style: styleName
                },
                dataType: 'text',
            });
            const styleElement = $.parseHTML('<style type="text/css"></style>');
            styleElement.html(styleHTML);
            $('head').append(styleElement);
            let isFontLoaded = yield FontLoader.waitForWebfonts(fontName + '_' + styleName);
            //console.log(fontName + '_' + styleName, isFontLoaded);
            this.fonts[productID][styleName] = true;
        });
    }
    static waitForWebfonts(font) {
        return __awaiter(this, void 0, void 0, function* () {
            let isFontLoaded = false;
            let node = document.createElement('span');
            node.innerHTML = 'giItT1WQy@!-/#';
            node.style.position = 'absolute';
            node.style.left = '-1000000px';
            node.style.top = '-1000000px';
            node.style.fontSize = '300px';
            node.style.fontFamily = 'serif';
            node.style.fontVariant = 'normal';
            node.style.fontStyle = 'normal';
            node.style.fontWeight = 'normal';
            node.style.letterSpacing = '0';
            document.body.appendChild(node);
            var width = node.offsetWidth;
            node.style.fontFamily = font;
            var interval = 0;
            function checkFont() {
                if (node && node.offsetWidth != width) {
                    if (interval)
                        clearInterval(interval);
                    node.parentNode.removeChild(node);
                    node = null;
                    isFontLoaded = true;
                    return true;
                }
                return false;
            }
            ;
            if (!checkFont()) {
                interval = window.setInterval(checkFont, 50);
            }
            return new Promise(resolve => {
                let iterationCount = 0;
                let interval = setInterval(() => {
                    if (isFontLoaded) {
                        clearInterval(interval);
                        resolve(true);
                    }
                    iterationCount++;
                    if (iterationCount > 10)
                        resolve(false);
                }, 100);
            });
        });
    }
}
FontLoader.fonts = [];
